<template>
  <div>
    <div
      class="z-50 bg-primary fixed h-full shadow-md pt-8 pb-16 pl-10 pr-9 flex flex-col justify-between"
      style="width: 19rem;"
    >
      <!-- Top -->
      <div class="mb-16">
        <router-link
          :to="{ name: 'MyClientsEntry' }"
          class="text-3xl font-black"
        >
          <span class="text-secondary">Nutri</span>
          <span>Bit</span>
        </router-link>
      </div>
      <!-- Center -->
      <div class="relative" style="top: -10%;">
        <div id="nav" class="h-72 flex flex-col justify-evenly">
          <NavigationItem :route="{ name: 'MyClients' }" icon="user-tie">
            My Clients
          </NavigationItem>
          <NavigationItem :route="{ name: 'MyCalendar' }" icon="calendar-alt">
            My Calendar
          </NavigationItem>
          <NavigationItem :route="{ name: 'MyMessages' }" icon="comment-dots">
            My Messages
          </NavigationItem>
          <NavigationItem :route="{ name: 'MyRecipes' }" icon="bread-slice">
            My Recipes
          </NavigationItem>
        </div>
        <hr />
        <div class="mx-auto mt-4 flex flex-col item-center">
          <p class="text-left">Next Appointments</p>
          <div class="mt-4 flex flex-col">
            <MenuAppointmentItem
              v-for="event in upcomingEvents"
              :key="`appointment-${event.id}`"
              :avatar="event.image"
              :name="`${event.client.name} ${event.client.surname}`"
              :time="event.time"
              @click.native="openAppointment(event)"
            />
          </div>
        </div>
      </div>
      <!-- Bottom -->
      <div>
        <router-link to="/logout">
          <FontAwesomeIcon icon="sign-out-alt" />
          Logout
        </router-link>
      </div>
    </div>
    <FadeTransition>
      <div v-if="$route.meta.showSearch" style="padding-left: 19rem;">
        <div
          class="z-50 fixed bg-primary h-20 px-6 flex justify-between items-center"
          style="width: calc(100% - 19rem)"
        >
          <div class="relative h-10 rounded-full overflow-hidden">
            <input
              class="h-full relative px-10"
              type="text"
              placeholder="Search"
            />
            <label
              class="text-gray-400 absolute top-0 bottom-0 left-4 flex items-center"
              for="text"
            >
              <FontAwesomeIcon icon="search" class="mr-2" />
            </label>
          </div>
          <div>
            <div
              class="flex items-center cursor-pointer"
              v-on-clickaway="hideMenu"
              @click="toggleMenu"
            >
              <Avatar class="mr-2" src="image2.jpg" :size="40" />
              <span>
                Nikandros
                <FontAwesomeIcon icon="chevron-down" class="ml-2" />
              </span>
            </div>
            <transition name="fade">
              <div
                v-show="showMenu"
                class="py-4 px-2 absolute right-4 bg-white"
              >
                <ul class="menu">
                  <li @click="toggleMenu">
                    <NavigationItem :route="{ name: 'MyProfile' }">
                      Profile
                    </NavigationItem>
                  </li>
                  <li @click="toggleMenu">
                    <NavigationItem :route="{ name: 'MySettings' }">
                      Settings
                    </NavigationItem>
                  </li>
                </ul>
              </div>
            </transition>
          </div>
        </div>
        <div class="pt-32" />
      </div>
    </FadeTransition>
    <div style="padding-left: 19rem;">
      <slot />
    </div>
  </div>
</template>

<script>
import NavigationItem from "@/components/NavigationItem";
import MenuAppointmentItem from "@/components/MenuAppointmentItem";
import { mapGetters } from "vuex";
import { mixin as clickaway } from "vue-clickaway";
import MyClientAppointmentModal from "@/pages/MyClients/components/MyClientAppointmentModal";
import FadeTransition from "@/components/transitions/FadeTransition";

export default {
  name: "MainLayout",
  components: {
    NavigationItem,
    MenuAppointmentItem,
    FadeTransition
  },
  mixins: [clickaway],
  props: {},
  computed: {
    ...mapGetters({ upcomingEvents: "getMyCalendarUpcomingEvents" })
  },
  data() {
    return {
      showMenu: false
    };
  },
  methods: {
    openAppointment(arrangedAppointment) {
      // show modal to view/cancel/reschedule appointment
      this.$modal.show(
        MyClientAppointmentModal,
        {
          appointment: arrangedAppointment
        },
        {
          name: "MyClientAppointmentModal",
          classes: "MyClientAppointmentModal rounded-xl overscroll-contain",
          height: "auto",
          maxWidth: 600,
          scrollable: true,
          adaptive: true
        }
      );
    },
    toggleMenu() {
      this.showMenu = true;
    },
    hideMenu() {
      this.showMenu = false;
    }
  },
  created() {
    this.$store.dispatch("fetchMyCalendarUpcomingEvents");
    this.$store.dispatch("fetchNutritionistDetails");
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins&display=swap");

#app {
  font-family: "Poppins", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  /* color: #42b983; */
  @apply bg-secondary;
  @apply text-white;
}

.menu li {
  @apply p-1;
}

.menu li:hover {
  background-color: rgb(231, 245, 245);
  cursor: pointer;
}
</style>
